// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OvjF","buttons":"styles_buttons__2It9Z"};